import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import { TypeService } from '@thewhite/react-global-module/lib/services';

export enum AccountTypeEnum {
    VK = 'VK',
    LDAP = 'LDAP',
    ESIA = 'ESIA',
    EMAIL = 'EMAIL',
    PHONE = 'PHONE',
    APPLE = 'ACTIVE',
    SYSTEM  = 'SYSTEM',
    TWITTER = 'TWITTER',
    FACEBOOK = 'FACEBOOK',
}

export interface AccountType {
    [value: string]: SimpleObjectInterface;

    VK: SimpleObjectInterface;
    ESIA: SimpleObjectInterface;
    LDAP: SimpleObjectInterface;
    APPLE: SimpleObjectInterface;
    EMAIL: SimpleObjectInterface;
    PHONE: SimpleObjectInterface;
    SYSTEM: SimpleObjectInterface;
    TWITTER: SimpleObjectInterface;
    FACEBOOK: SimpleObjectInterface;
}

const ACCOUNT_TYPE: AccountType = {
    EMAIL: {
        name: 'E-mail',
        value: 'EMAIL',
    },
    PHONE: {
        name: 'Телефон',
        value: 'PHONE',
    },
    ESIA: {
        name: 'Гос. услуги',
        value: 'ESIA',
    },
    APPLE: {
        name: 'Apple',
        value: 'APPLE',
    },
    LDAP: {
        name: 'Лдап',
        value: 'LDAP',
    },
    VK: {
        name: 'ВКонтакте',
        value: 'VK',
    },
    FACEBOOK: {
        name: 'Фейсбук',
        value: 'FACEBOOK',
    },
    TWITTER: {
        name: 'Твиттер',
        value: 'TWITTER',
    },
    SYSTEM: {
        name: 'Системный',
        value: 'SYSTEM',
    },
};

export default ACCOUNT_TYPE;

export const AccountTypeEnumType = TypeService.createEnum<AccountTypeEnum>(AccountTypeEnum, 'AccountTypeEnum');
